import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './actions'
import { Tabs } from '../root/components/common'
import Location from './location'
import LocationDevices from './location-devices'
import LocationShareInfo from './location-share-info'
import LocationReports from './location-reports'
import LocationStatistics from './location-statistics'
import LocationFloorPlan from './location-floor-plan'
import Device from '../devices/device'
import PrivateRoute from '../root/components/private-route'
import LocationPictures from './location-pictures'
import LocationNetworkDevices from './location-network-devices'
import TasksComponent from './tasks-component'
import LocationEscalationLevels from './location-escalation-levels'
import LocationSettings from './location-settings'
import LocationActions from './location-actions'

const useStyles = makeStyles({
    wrapper: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    tabs: {
        marginBottom: 15
    }
})

function LocationDetails(props) {
    const classes = useStyles()

    const {
        pickerLocations,
        selectLocation,
        selectedLocation,
        setSelectedLocation,
        isDevicesToMoveMode,
        setIsDevicesToMoveMode,
        isNetworkDevicesToMoveMode,
        setIsNetworkDevicesToMoveMode,
        locationId,
        onAddSubLocation
    } = props

    const isNew = locationId === 'new'
    const { locale } = useSelector(state => state.main)

    const dispatch = useDispatch()

    const tabs = {
        overview: {
            key: 'overview',
            name: locale.locations.overview,
            disabled: isDevicesToMoveMode || isNetworkDevicesToMoveMode
        },
        floor_plan: {
            key: 'floor_plan',
            name: locale.locations.floorPlan,
            disabled: isNew || isDevicesToMoveMode || isNetworkDevicesToMoveMode
        },
        tasks: {
            key: 'tasks',
            name: locale.locations.tasks,
            disabled: isNew || isDevicesToMoveMode || isNetworkDevicesToMoveMode
        },
        devices: {
            key: 'devices',
            name: locale.locations.devices,
            disabled: isNew || isNetworkDevicesToMoveMode
        },
        network: {
            key: 'network',
            name: locale.locations.network,
            disabled: isNew || isDevicesToMoveMode
        },
        reports: {
            key: 'reports',
            name: locale.locations.reports,
            disabled: isNew || isDevicesToMoveMode || isNetworkDevicesToMoveMode
        },
        pictures: {
            key: 'pictures',
            name: locale.locations.pictures,
            disabled: isNew || isDevicesToMoveMode || isNetworkDevicesToMoveMode
        },
        escalation_levels: {
            key: 'escalation_levels',
            name: locale.locations.escalationLevels,
            disabled: isNew || isDevicesToMoveMode || isNetworkDevicesToMoveMode
        },
        share_info: {
            key: 'share_info',
            name: locale.locations.shareInfo,
            disabled: isNew || isDevicesToMoveMode || isNetworkDevicesToMoveMode
        },
        stats: {
            key: 'stats',
            name: locale.locations.stats,
            disabled:
                isNew || isDevicesToMoveMode || isNetworkDevicesToMoveMode,
            withBetaBadge: true
        },
        settings: {
            key: 'settings',
            name: locale.common.settings,
            disabled:
                isNew || isDevicesToMoveMode || isNetworkDevicesToMoveMode,
            withBetaBadge: true
        },
        actions: {
            key: 'actions',
            name: locale.locations.actions,
            disabled:
                isNew || isDevicesToMoveMode || isNetworkDevicesToMoveMode,
            withBetaBadge: true
        }
    }

    const tabsRoutesMap = {
        devices: 'devices',
        network: 'network',
        overview: 'overview',
        reports: 'reports',
        stats: 'statistics',
        share_info: 'share-info',
        pictures: 'pictures',
        floor_plan: 'floor-plan',
        tasks: 'tasks',
        escalation_levels: 'escalation-levels',
        settings: 'settings',
        actions: 'actions'
    }

    const routesTabsMap = {
        devices: 'devices',
        network: 'network',
        overview: 'overview',
        reports: 'reports',
        statistics: 'stats',
        'share-info': 'share_info',
        pictures: 'pictures',
        'floor-plan': 'floor_plan',
        tasks: 'tasks',
        'escalation-levels': 'escalation_levels',
        settings: 'settings',
        actions: 'actions'
    }

    // const [currentTab, setCurrentTab] = useState(isNew ? tabs.overview.key : tabs.devices.key)

    const getCurrentTab = () => {
        try {
            const locationPart = props.location.pathname.split('/')[3]
            return routesTabsMap[locationPart]
        } catch (ex) {
            return ''
        }
    }

    const onSetCurrentTab = tabKey => {
        if (!isNew) {
            props.history.push(
                `/locations/${locationId}/${tabsRoutesMap[tabKey]}`
            )
        }
    }

    useEffect(() => {
        /* if (locationId && locationId !== 'new') {
            props.setSelectedLocation(locationId)
        } */
        if (!isNew && getCurrentTab() !== 'floor_plan') {
            dispatch(actions.locationRequest(locationId))
        }
        if (Number(selectedLocation) !== Number(locationId)) {
            setSelectedLocation(locationId)
        }
        if (isNew)
            props.history.replace(
                `/locations/${locationId}/${tabsRoutesMap.overview}`
            )
    }, [locationId])

    useEffect(() => {
        if (isDevicesToMoveMode) {
            props.history.push(
                `/locations/${locationId}/${tabsRoutesMap.devices}`
            )
        }
        if (isNetworkDevicesToMoveMode) {
            props.history.push(
                `/locations/${locationId}/${tabsRoutesMap.network}`
            )
        }
    }, [isDevicesToMoveMode, isNetworkDevicesToMoveMode])

    return (
        <div className={classes.wrapper}>
            <Tabs
                className={classes.tabs}
                tabs={tabs}
                currentTab={getCurrentTab()}
                setCurrentTab={onSetCurrentTab}
                variant="scrollable"
                centered={false}
                scrollButtons="auto"
            />
            <PrivateRoute
                exact
                path="/locations/:locationId/devices"
                render={() => (
                    <LocationDevices
                        isDevicesToMoveMode={isDevicesToMoveMode}
                        setIsDevicesToMoveMode={setIsDevicesToMoveMode}
                    />
                )}
            />
            <PrivateRoute
                exact
                path="/locations/:locationId/network"
                render={() => (
                    <LocationNetworkDevices
                        isDevicesToMoveMode={isNetworkDevicesToMoveMode}
                        setIsDevicesToMoveMode={setIsNetworkDevicesToMoveMode}
                    />
                )}
            />
            <PrivateRoute
                exact
                path="/locations/:locationId/devices/:deviceId"
                render={() => <Device />}
            />
            <PrivateRoute
                exact
                path="/locations/:locationId/overview"
                render={() => (
                    <Location
                        onAddSubLocation={onAddSubLocation}
                        pickerLocations={pickerLocations}
                        selectLocation={selectLocation}
                    />
                )}
            />
            <PrivateRoute
                exact
                path="/locations/:locationId/reports"
                render={() => <LocationReports />}
            />
            <PrivateRoute
                exact
                path="/locations/:locationId/statistics"
                render={() => <LocationStatistics />}
            />
            <PrivateRoute
                exact
                path="/locations/:locationId/share-info"
                render={() => <LocationShareInfo />}
            />
            <PrivateRoute
                exact
                path="/locations/:locationId/pictures"
                render={() => <LocationPictures />}
            />
            <PrivateRoute
                exact
                path="/locations/:locationId/tasks"
                render={() => <TasksComponent />}
            />
            <PrivateRoute
                exact
                path="/locations/:locationId/floor-plan"
                render={() => <LocationFloorPlan />}
            />
            <PrivateRoute
                exact
                path="/locations/:locationId/escalation-levels"
                render={() => <LocationEscalationLevels />}
            />
            <PrivateRoute
                exact
                path="/locations/:locationId/settings"
                render={() => <LocationSettings />}
            />
            <PrivateRoute
                exact
                path="/locations/:locationId/actions"
                render={() => <LocationActions />}
            />
        </div>
    )
}

export default withRouter(LocationDetails)
